import React, { ReactElement, ReactNode } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type LinkWithTooltipProps = { id: string; children: ReactNode; href: string; tooltip: ReactNode };

export function LinkWithTooltip(props: LinkWithTooltipProps): ReactElement {
    const { id, children, href, tooltip } = props;
    return (
        <OverlayTrigger overlay={<Tooltip id={id}>{tooltip}</Tooltip>} placement="top">
            <a href={href}>{children}</a>
        </OverlayTrigger>
    );
}
